<template>
    <div class="card-wrapper" :class="!headVisible ? scrollTarget : ''">
        <v-card class="mr-2 ml-2 elevation-2">
            <div class="offset-header">
                <v-card
                    v-if="headVisible"
                    color="offsetCardHeaderColor"
                    class="header-card border-r-5 card-header elevation-0"
                >
                    <v-card-title class="headline" :class="headVisible ? scrollTarget : ''">
                        <v-layout row justify-space-between>
                            <v-flex md1 v-if="!!icon">
                                <v-icon
                                    :color="theme.offsetCardHeaderTextColor"
                                    v-if="!!icon"
                                    x-large
                                    class="material-icons">
                                    {{ icon }}
                                </v-icon>
                            </v-flex>
                            <v-flex
                                :md8="!loading && $slots.header"
                                :md11="!loading && !$slots.header"
                                :xs11="loading && !!icon"
                                :xs12="loading && !(!!icon)"
                                style="color: var(--v-offsetCardHeaderTextColor-base);"
                                class="ml-5 title"
                            >
                                {{ blockTitle }}
                                <v-progress-circular
                                    indeterminate
                                    v-if="loading"
                                    color="secondary"
                                    style="float: right; margin-right: 20px"
                                ></v-progress-circular>
                            </v-flex>
                            <v-flex v-if="!loading && $slots.header" md3 class="mr-5">
                                <slot name="header"></slot>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                </v-card>
            </div>
            <v-card-text class="card-text">
                <slot name="error"/>
                <slot name="block-elements"/>
            </v-card-text>
            <v-card-actions>
                <slot name="actions"/>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

export default {
    props: {
        scrollTarget: {
            type: String,
            default: 'no-scroll-target',
        },
        headVisible: {
            type: Boolean,
            required: false,
            default: true,
        },
        blockTitle: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.card-wrapper {
    margin-top: 50px;
    width: 100%
}

.offset-header {
    position: relative;
    top: -26px !important;
    margin-inline: auto;
    max-width: calc(100% - 32px);
}

.border-r-5 {
    /* border-radius: 5px;*/
}

.header-card {
    margin: 0 auto;
    max-width: calc(100% - 32px);
    height: 52px;
    color: white !important;
    /*font-weight: bold;*/
    font-size: 24px;
}

.card-header {
    transition: all ease-in-out 0.3s;
}

.headline {
    height: 100%;
    flex-wrap: nowrap !important;
    font-weight: 200 !important;
    font-size: 24px !important;
}

.card-text {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.title {
    padding-top: 2px;
}
</style>
